import * as S from './ProviderLabel.styles'

export type ProviderLabelProps = {
  providerIconUrl?: string
  providerName?: string
}

export default function ProviderLabel({
  providerIconUrl,
  providerName = 'XL Axiata'
}: ProviderLabelProps) {
  return (
    <S.Container>
      <S.ContentWrapper>
        {providerIconUrl && (
          <S.IconContainer>
            <S.ProviderIcon
              src={providerIconUrl}
            />
          </S.IconContainer>
        )}
        <S.ProviderName>
          {providerName}
        </S.ProviderName>
      </S.ContentWrapper>
    </S.Container>
  )
}
